import { Collection, } from "@bluelibs/x-ui";
import { Profile } from "@root/api.types";
import { AgenciesCollection, ClientRequestRelatedContactsCollection, UsersCollection, } from "@bundles/UIAppBundle/collections";
export class ProfilesCollection extends Collection {
    getName() {
        return "Profiles";
    }
    getInputs() {
        return {
            insert: "ProfileInsertInput!",
            update: "ProfileUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [
            {
                collection: () => AgenciesCollection,
                name: "agency",
                field: "agencyId",
            },
            {
                collection: () => UsersCollection,
                name: "createdBy",
                field: "createdById",
            },
            {
                collection: () => UsersCollection,
                name: "updatedBy",
                field: "updatedById",
            },
            {
                collection: () => UsersCollection,
                name: "user",
                field: "userId",
            },
            {
                collection: () => ClientRequestRelatedContactsCollection,
                name: "clientRequestRelatedContacts",
            },
        ];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
